import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { startup } from '@shared/rxjs-operators';
import { BehaviorSubject, finalize, Observable, of, switchMap, tap } from 'rxjs';
import { VersionApiService } from 'src/.api-client/services/version-api.service';
import { v4 as uuidv4 } from 'uuid';
import { SKIP_HEADER_INTERCEPTOR } from '@delab/ngx-ixconnect-components';

@Injectable({ providedIn: 'root' })
export class ServiceVersionService {
    private readonly isServiceVersionSupportedSubject: BehaviorSubject<boolean | undefined> = new BehaviorSubject<boolean | undefined>(
        undefined,
    );
    public readonly isServiceVersionSupportedObs = this.isServiceVersionSupportedSubject.asObservable();

    private isLoading: boolean = false;

    constructor(private readonly _versionApiService: VersionApiService) {}

    public isServiceVersionSupported(): Observable<boolean> {
        const existingValue = this.isServiceVersionSupportedSubject.getValue();

        if (existingValue === true) {
            return of(existingValue);
        }

        // TODO: Mit loadingObs umsetzen, darauf warten, dass nicht mehr geladen wird, und neuen Wert verwenden
        // Aktuell wird hier, wenn gerade geladen wird, der alte Wert verwendet
        if (this.isLoading) {
            return this.isServiceVersionSupportedObs.pipe(
                switchMap((isServiceVersionSupported) => {
                    if (isServiceVersionSupported === true) {
                        return of(isServiceVersionSupported);
                    }

                    return this.#loadIsServiceVersionSupported();
                }),
            );
        }

        return this.#loadIsServiceVersionSupported();
    }

    #loadIsServiceVersionSupported() {
        return this._versionApiService
            .versionIsVersionSupported({ 'x-trace-id': uuidv4() }, new HttpContext().set(SKIP_HEADER_INTERCEPTOR, true))
            .pipe(
                startup(() => (this.isLoading = true)),
                tap((config) => this.isServiceVersionSupportedSubject.next(config)),
                finalize(() => (this.isLoading = false)),
            );
    }
}
